import * as React from 'react';
import { TLocalization } from './Localization.types';
import { Button } from 'components';
import { Add } from '@mui/icons-material';
import '../../AdminPanel.styles.scss';
import { MODALS } from 'store/contexts/ModalContext/modals';
import { useModals } from 'hooks/useModals';
import { LocalizationTable } from './components/LocalizationTable/LocalizationTable';

export const Localization: TLocalization = () => {
  const modals = useModals();

  const openModal = () => {
    modals.openModal(MODALS.ADMIN_LOCALIZATION_ADD);
  };

  return (
    <div className="admin-entity">
      <div className="admin-entity__header">
        <div>
          <h4>Static Localization</h4>
        </div>
        <div className="admin-entity__header__buttons-contaier">
          <Button variant="contained" endIcon={<Add />} onClick={openModal}>
            Add Static Localization
          </Button>
        </div>
      </div>
      <LocalizationTable />
    </div>
  );
};
